import DialogUserDecision from './DialogUserDecision';

export default DialogUserDecision;
